import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'; // Import useLocation here
import OrderPage from './components/order/OrderPage';
import ContactUs from './components/contactUs/ContactUs';
import AboutUs from './components/aboutUs/AboutUs';
import Popular from './components/populer/popular';
import ShopByConcern from './components/shopbyconcern/ShopByConcern';
import HeaderNavbar from './components/header-navbar/Header-Navbar';
import ReviewPage from './components/review/ReviewPage';
import HowToOrder from './components/order/how-to-order';
import Admin from './components/admin/admin';
import { Provider } from 'react-redux';
import store from './redux/store'
import UserOrders from './components/user/userOrders';
import NewLaunchProduct from './components/newLaunch/newLaunchProduct';
import Cart from './components/cart/cart';
import LoginForm from './components/login/login';
import CartDiv from './components/cart/cartDiv';
import OrderCartItem from './components/order/orderCartItem';
import FAQPage from './components/faq/faq';
import BlogPage from './components/blog/blog';
import TermsAndConditions from './components/TermsAndCondition/TermsAndConditions';
// Define the MainApp component to use useLocation
const MainApp = () => {
  const location = useLocation(); // Now it will work, since it's wrapped by <Router>

  return (
    <>
      <HeaderNavbar />
      <div className="main-container">
        <Routes>
          {/* Home Route - base of your site */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/" element={<App />} />
          <Route path="/admin" element={<Admin />} />
          {/* Routes with prefix */}
          <Route path="/my-orders" element={<UserOrders />} />
          <Route path="/my-cart" element={<Cart />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/order/:productId" element={<OrderPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/popular" element={<Popular />} />
          <Route path="/concern" element={<ShopByConcern />} />
          <Route path="/how-to-order" element={<HowToOrder />} />
          <Route path="/new-launch-product" element={<NewLaunchProduct />} />
          <Route path="/order-cart-item" element={<OrderCartItem />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/terms_conditions" element={<TermsAndConditions />} />

        </Routes>
        {
          (location.pathname !== '/admin' && location.pathname !== '/login') && <CartDiv />
        }
      </div>
    </>
  );
};

const Root = () => (
  <Provider store={store}>
    <Router>
      <MainApp />
    </Router>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));
